import { createApp } from "vue";

import App from "./App.vue";
import Axios from "axios";
import Cookie from "./utils/cookies.js";
import useApi from "./utils/apiCalls.js";
import Router, { isPublicRoute } from "./router/index";

import "normalize.css";
import "./assets/styles/main.less";

window.addEventListener('vite:preloadError', () => {
  window.location.reload();
});

const { getCookie } = Cookie();
const { apiPostRequest } = useApi();

const report = errorPayload => {
  console.error(errorPayload);
  // eslint-disable-next-line no-undef
  errorPayload.app = "flightfox-app [" + __APP_VERSION__.substring(0, 16).replace("T", " ") + "]";
  apiPostRequest({ path: "/error-report", data: errorPayload, onSuccess: () => console.log("Error reported."), onError: error => console.error("Failed to report error:", error) });
};

const jwt = getCookie("jwt");
if (!jwt && !isPublicRoute(window.location.pathname)) {
  window.location.href = "/login";
} else {
  const app = createApp(App);

  // Vue rendering errors
  app.config.errorHandler = (err, vm, info) => {
    try {
      report({
        message: err?.message || "Unknown error",
        stack: err?.stack,
        component: vm?.$options?.name || "unknown component",
        info,
        url: window.location.href,
      });
    } catch (e) {
      console.error("Error in errorHandler:", e);
    }
  };

  //unhandled exceptions
  window.onerror = function (message, source, lineno, colno, error) {
    report({ message, source, lineno, colno, stack: error ? error.stack : "No stack trace", url: window.location.href });
  };

  // unhandled promise rejections handler
  window.onunhandledrejection = function (event) {
    let message = "Unhandled promise rejection";
    let details = "Reason details unavailable";
    const reason = event.reason;

    if (reason instanceof Error) {
      // Standard case: The promise was rejected with an Error object
      message = reason.message || "Error object without a message";
      details = reason.stack || `Type: ${reason.name || "Error"}`;
    } else {
      try {
        // Try to get a meaningful representation of the reason
        if (typeof reason === "object" && reason !== null) details = `Type: ${typeof reason}, Value: ${JSON.stringify(reason)}`;
        else details = `Type: ${typeof reason}, Value: ${String(reason)}`;
        // eslint-disable-next-line no-unused-vars
      } catch (e) {
        // Fallback if stringify fails (e.g., circular references)
        details = `Type: ${typeof reason}, Value: [Could not stringify reason]`;
      }
    }

    // Send the report with potentially more info
    report({ message: message, stack: details, url: window.location.href });
  };

  app.config.unwrapInjectedRef = true;
  app.provide("axios", Axios);
  app.provide("jwt", jwt);
  app.use(Router);
  app.mount("#app");
}
